<template>
  <div
    class="modal fade"
    id="orderIdReceiptModal"
    tabindex="-1"
    role="dialog"
    data-backdrop="static"
    data-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content total bg-t_light-greyish-blue">
        <!-- HEADER -->
        <div class="modal-header" :class="[$breakpoint.mdAndDown ? 'flex-column' : 'align-items-center pt-5']">
          <h1 class="modal-title mt-0 heading-large">
            <i class="fas fa-check-circle text-t_green mr-2 fa-lg" v-if="currentOrderHasBeenConfirmed"></i>
            <span :class="{ 'pl-3': !currentOrderHasBeenConfirmed }">{{ orderReceiptTitle }}</span>
          </h1>
          <button type="button" class="modal-close" data-dismiss="modal" @click="closeModal()" aria-label="Cancel">
            <i class="fas fa-lg fa-times"></i>
          </button>
          <div>
            <!-- DATE -->
            {{ orders[0].date }}
          </div>
        </div>
        <!-- BUYER & SELLER -->
        <div class="modal-body">
          <div
            class="row justify-content-between bg-white shadow p-3 pb-4 mb-4 mx-0"
            :class="{ 'w-50': !$breakpoint.mdAndDown }"
          >
            <div v-if="getAccountType === 'seller'" class="col-12">
              <h2 class="border-bottom pb-2">Customer</h2>
              <address class="mb-0">
                {{ getBuyerUser.firstName }} {{ getBuyerUser.lastName }}
              </address>
              <address class="mb-0">{{ getBuyerUser.email }}</address>
            </div>
            <div class="col-12" v-else-if="isBuyer">
              <h2 class="border-bottom pb-2">Seller</h2>
              <span class="border-bottom mb-2"></span>
              <address class="mb-0">{{ sellerAccount.name }}</address>
              <address class="mb-0">{{ sellerAccount.email }}</address>
            </div>
          </div>
          <div class="bg-white shadow p-3 pb-4 mb-4 mx-0">
            <el-row :gutter="20" v-if="currentOrderDetailsFirstItem">
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span class="font-weight-bold"> Order Id </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span>
                  {{ currentOrderDetailsFirstItem.orderId }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span class="font-weight-bold" v-if="getAccountType==='seller'"> Customer </span>
                <span class="font-weight-bold" v-else> Seller </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span>
                  {{ currentOrderDetailsFirstItem.account }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
                <span class="font-weight-bold"> Payment Terms </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="currentOrderDetailsFirstItem && !isContract">
                <span>
                  {{ currentOrderDetailsFirstItem.credit_days }}
                </span>
              </el-col>
              <el-col
                :xs="12"
                :sm="12"
                :md="4"
                :lg="3"
                class="pt-1"
                v-if="isDeliveredIn && currentOrderDetailsFirstItem"
              >
                <span class="font-weight-bold"> Delivery Date </span>
              </el-col>
              <el-col
                :xs="12"
                :sm="12"
                :md="4"
                :lg="3"
                class="pt-1"
                v-if="isDeliveredIn && currentOrderDetailsFirstItem"
              >
                <span>
                  {{ currentOrderDetailsFirstItem.deliveryDate }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span class="font-weight-bold"> Date </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span class="text-nowrap">
                  {{ currentOrderDetailsFirstItem.date }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="!isBunkering">
                <span class="font-weight-bold">
                  Terminal
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="!isBunkering">
                <span>
                  {{ currentOrderDetailsFirstItem.terminal }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" v-if="isDeliveredIn" class="pt-1">
                <span class="font-weight-bold"> Delivery Location </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" v-if="isDeliveredIn" class="pt-1">
                <span>
                  {{ currentOrderDetailsFirstItem.delivery_location }}
                </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="hasMultipleRefs() === false">
                <span class="font-weight-bold"> Ref </span>
              </el-col>
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1" v-if="hasMultipleRefs() === false">
                <span>
                  {{ currentOrderDetailsFirstItem.reference ? currentOrderDetailsFirstItem.reference : '-'  }}
                </span>
              </el-col>
              <el-col
                :xs="12"
                :sm="6"
                :md="4"
                :lg="3"
                v-if="currentOrderDetailsFirstItem && !isBunkering"
                :class="!currentOrderHasBeenCancelled ? 'pt-2' : 'pt-2'"
              >
                <span class="font-weight-bold"> Lifting Period </span>
              </el-col>
              <el-col
                :xs="12"
                :sm="13"
                :md="6"
                :lg="6"
                class="pt-2"
                v-if="currentOrderDetailsFirstItem && !isBunkering"
              >
                <span>
                  {{ currentOrderDetailsFirstItem | liftingperiodformat }}
                </span>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="currentOrderDetailsFirstItem">
              <el-col :xs="12" :sm="6" :md="4" :lg="3" class="pt-1">
                <span class="font-weight-bold"> Status </span>
              </el-col>
              <el-col :xs="12" :sm="12" :md="6" :lg="5" class="pt-1" :class="`text-${calculateOrderDisplay().textColor}`">
                <span>
                  {{ calculateOrderDisplay().text }}
                </span>
              </el-col>
            </el-row>
          </div>
          <!-- Cards for smaller Screens -->
          <div v-if="currentOrderDetailsFirstItem && $breakpoint.mdAndDown" class="pb-2 bg-white">
            <el-card class="py-1 mb-3" v-for="(order, index) in currentOrderDetails" :key="index">
              <el-row :gutter="20">
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering"> <span class="font-weight-bold"> Product </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering">
                  <span> {{ order.fuel }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering"> <span class="font-weight-bold"> Network </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                  <span> {{ order.terminal }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                  <span class="font-weight-bold"> Ref </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="hasMultipleRefs()">
                  <span> {{ getReferenceLineNumber(index) }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                  <span class="font-weight-bold"> Order ID </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="manageOrderNumbersEnabled">
                  <span> {{ order.orderId ? order.orderId : "-" }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                  <span class="font-weight-bold"> Release No. </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                  <span> {{ order.releaseNumber ? order.releaseNumber : "-" }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                  <span class="font-weight-bold"> Movement No. </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBunkering && manageOrderNumbersEnabled">
                  <span> {{ order.movementNumber ? order.movementNumber : "-" }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                  <span class="font-weight-bold"> Account No. </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isBunkering">
                  <span> {{ order.bunkeringAccountNumber }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="brand">
                  <span class="font-weight-bold"> Credit Line </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="brand">
                  <span> {{ brand }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Bio Pricing </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1">
                  <span> {{ order.bioPrice }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Measurement </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1">
                  <span> {{ order.measurement }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                  <span class="font-weight-bold"> Payment Terms </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isContract">
                  <span> {{ order.credit_days }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBuyer || (isBuyer && !isDeliveredIn)">
                  <span class="font-weight-bold"> {{ isDeliveredIn ? "Ex-Rack Price ppl" : "Price ppl" }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="!isBuyer || (isBuyer && !isDeliveredIn)">
                  <span> {{ isDeliveredIn ? order.exrack : order.price }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn && !isBuyer">
                  <span class="font-weight-bold"> Haulage ppl </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn && !isBuyer">
                  <span> {{ order.haulage }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                  <span class="font-weight-bold"> Delivered Price </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1" v-if="isDeliveredIn">
                  <span> {{ order.price }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Vol/L </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1">
                  <span> {{ order.quantity }} </span>
                </el-col>
                <el-col :xs="12" :sm="12" class="pt-1"> <span class="font-weight-bold"> Total (£) </span> </el-col>
                <el-col :xs="12" :sm="12" class="pt-1">
                  <span> {{ order.offerTotal }} </span>
                </el-col>
              </el-row>
              <orderPriceBreakDown v-if="showPriceBreakdown && getOrderMarketWindow"
                :cards="true"
                :index="index"
                :order="order"
                :getOrderMarketWindow="getOrderMarketWindow"
                :productConfig="productConfig"
                :bioProductConfig="bioProductConfig"
                :isContract="isContract"
              />
            </el-card>
          </div>
          <!-- Table for larger Screens -->
          <el-row class="pb-2 bg-white" v-if="$breakpoint.lgAndUp">
            <el-col :span="24">
              <el-table
                ref="table"
                :data="currentOrderDetails"
                :fit="true"
                size="mini"
                :header-cell-class-name="tableHeaderClass"
                :row-class-name="tableRowClassName"
              >
                <el-table-column align="left" min-width="20px">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="pr-1"
                      content="This item has been removed from the order" 
                      placement="top"
                      v-if="scope.row.lineItemCancelled"
                    >
                      <i
                        class="fas fa-flag pr-1 text-t_red"
                      >
                      </i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Product" min-width="120px" v-if="!isBunkering">
                  <template slot-scope="scope">
                    <span>{{ scope.row.fuel }}</span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Network" min-width="120px" v-if="isBunkering">
                  <template slot-scope="scope">
                    <span>{{ scope.row.terminal }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="left"
                  label="Order ID"
                  v-if="manageOrderNumbersEnabled"
                  min-width="100px"
                >
                  <template slot-scope="scope">
                    <span> {{ scope.row.orderId ? scope.row.orderId : "-" }} </span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="left"
                  label="Release No."
                  v-if="!isBunkering && manageOrderNumbersEnabled"
                  :min-width="brand ? '100px' : '120px'"
                >
                  <template slot-scope="scope">
                    <span> {{ scope.row.releaseNumber ? scope.row.releaseNumber : "-" }} </span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="left"
                  label="Movement No."
                  v-if="!isBunkering && manageOrderNumbersEnabled"
                  :min-width="brand ? '100px' : '120px'"
                >
                  <template slot-scope="scope">
                    <span> {{ scope.row.movementNumber ? scope.row.movementNumber : "-" }} </span>
                  </template>
                </el-table-column>
                <el-table-column
                  align="left"
                  label="Account No."
                  v-if="isBunkering"
                  :min-width="brand ? '100px' : '120px'"
                >
                  <template slot-scope="scope">
                    <span> {{ scope.row.bunkeringAccountNumber }} </span>
                  </template>
                </el-table-column>
                 <el-table-column
                  align="left"
                  label="Ref"
                  v-if="hasMultipleRefs()"
                  :min-width="brand ? '100px' : '120px'"
                >
                  <template slot-scope="scope">
                    <span> {{ getReferenceLineNumber(scope.$index) }} </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" v-if="brand" label="Credit Line" min-width="80px">
                  <template>
                    <span> {{ brand }} </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Bio Pricing" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.bioPrice }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Measurement" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.measurement }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Payment Terms" v-if="isContract" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.credit_days }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="!isBuyer || (isBuyer && !isDeliveredIn)"
                  align="left"
                  :label="isDeliveredIn ? 'Ex-Rack Price ppl' : 'Price ppl'"
                  min-width="120px"
                >
                  <template slot-scope="scope">
                    <span>
                      {{ isDeliveredIn ? scope.row.exrack : scope.row.price }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Haulage ppl" v-if="isDeliveredIn && !isBuyer" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.haulage }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Delivered Price" v-if="isDeliveredIn" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.price }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Vol/L" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.quantity }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column align="left" label="Total (£)" min-width="100px">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.offerTotal }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column v-if="showPriceBreakdown" width="50px">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="light"
                      :content="
                        expandedRowIndex.includes(scope.$index) ? 'Hide Price Breakdown' : 'Show Price Breakdown'
                      "
                      placement="top"
                    >
                      <i
                        class="mr-1 text-t_blue"
                        :class="expandedRowIndex.includes(scope.$index) ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                        style="font-size: 20px"
                        @click="toggleExpand(scope.row, scope.$index)"
                      >
                      </i>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column type="expand" v-if="showPriceBreakdown" width="1px">
                  <template slot-scope="scope">
                    <orderPriceBreakDown v-if="currentOrderDetailsFirstItem.pricingEngineEnabled && getOrderMarketWindow"
                      :key="scope.$index"
                      :index="scope.$index"
                      :order="scope.row"
                      :getOrderMarketWindow="getOrderMarketWindow"
                      :productConfig="productConfig"
                      :bioProductConfig="bioProductConfig"
                      :isContract="isContract"
                    />
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row class="bg-white pt-2 pb-2 mx-0" :gutter="20">
            <el-col :xs="24" :md="12" class="py-2">
              <el-card style="min-height: 110px;">
                <label> Order Notes </label>
                <br/>
                {{ currentOrderDetailsFirstItem.orderNotes }}
              </el-card>
            </el-col>
            <el-col :xs="24" :md="12" class="py-2 customCard">
              <el-card style="min-height: 110px;" :shadow="'never'">
                <el-row :class="{'text-right justify-content-right' : $breakpoint.lgAndUp }">
                  <el-col :xs="12" :sm="12" :md="12" :lg="18">
                    <label> Total ex VAT </label>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    £ {{ currentOrderDetailsFirstItem.totalExVat }}
                  </el-col>
                </el-row>
                <el-row :class="{'text-right justify-content-right' : $breakpoint.lgAndUp }" v-if="currentOrderDetailsFirstItem.vatCost != null">
                  <el-col :xs="12" :sm="12" :md="12" :lg="18">
                    <label> VAT </label>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    £ {{ currentOrderDetailsFirstItem.vatCost }}
                  </el-col>
                </el-row>
                <el-row :class="{'text-right justify-content-right' : $breakpoint.lgAndUp }" v-if="currentOrderDetailsFirstItem.vatCost != null">
                  <el-col :xs="12" :sm="12" :md="12" :lg="18">
                    <label> Total inc VAT </label>
                  </el-col>
                  <el-col :xs="12" :sm="12" :md="12" :lg="6">
                    £ {{ currentOrderDetailsFirstItem.totalIncVat }}
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="modal-footer justify-content-center">
          <button class="btn btn-neutral" :class="{'mr-2' : !$breakpoint.mdAndDown}" id="cancelButton" data-dismiss="modal" @click="closeModal()"> Close</button>
          <button class="btn btn-confirm" :class="{'mr-2' : !$breakpoint.mdAndDown}" id="confirmOrder" data-dismiss="modal" @click="closeModalAndConfirmOrder()" v-if="isEditOrdersEnabled && showOrderHistoryLink"> {{ manageOrderNumbersEnabled ? 'Add Order Numbers' : 'Confirm Order' }}</button>
          <router-link v-if='showOrderHistoryLink' class="text-t_blue" :class="{'mr-2' : !$breakpoint.mdAndDown}" @click="closeModal()" data-dismiss="modal" to=/OrderHistory/all>
              Go to order history
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import conversationStarterMixin from "@/mixins/ConversationStarterMixin";
import { getOrderStatusDisplay } from "@/util/orderBuilder";
import breakpoint from "@/mixins/index";
import { formatStringToNumber } from "@/util/util";
import { getUserInformation, getAccountInformation } from "../api/users";
import { getBasket } from "../api/basket.js";
import orderPriceBreakDown from "../components/Tools/OrderPriceBreakDown.vue"

export default {
  components: {
    orderPriceBreakDown
  },
  data() {
    return {
      expandedRowIndex: [],
      buyerUser: { firstName: "N/A", lastName: "N/A", email: "N/A", _id: null },
      sellerAccount: { name: "N/A", email: "N/A" },
      orderBasket: null,
      orderMarketWindow: null,
    };
  },
  props: ["orders", "showOrderHistoryLink"],
  mixins: [conversationStarterMixin, breakpoint],
  created: async function () {
    if (this.orders[0].basket_id) {
      this.orderBasket = await getBasket(this.orders[0].basket_id);
      this.orderMarketWindow = this.orderBasket.marketWindow;
    }
    await this.getBuyerUserSellerAccount();
  },
  mounted: function () {
    $("#orderIdReceiptModal").modal("show");
  },
  computed: {
    ...mapGetters("login", ["getAccountType"]),
    ...mapGetters("metadata", ["bioProductConfig", "productConfig", "blendedProductConfig", "staMatrix"]),
    isEditOrdersEnabled() {
      return this.$store.getters["login/isEditOrdersEnabled"] && this.getAccountType == 'seller';
    },
    getBuyerUser() {
      return this.buyerUser;
    },
    showPriceBreakdown() {
      return this.getAccountType == 'seller' && this.currentOrderDetailsFirstItem.pricingEngineEnabled;
    },
    getOrderMarketWindow() {
      return this.orderMarketWindow;
    },
    orderReceiptTitle: function () {
      const { product_type, offer_type, haulage, originalOrderId, orderId, contractNumber } = this.orders[0];
      const displayId = contractNumber || originalOrderId || orderId;

      if (offer_type === "Contract") {
        // Contract Orders
        if (product_type === "Spot") return `Ex-Rack Contract Order - ${displayId}`;
        else if (product_type === "Bunkering") return `Bunkering Contract Order - ${displayId}`;
      } else {
        // Spot Orders
        if (product_type === "Bunkering") return `Bunkering Order - ${displayId}`;
        else if (haulage) return `Delivered In Order - ${displayId}`;
        else return `Ex-Rack Order - ${displayId}`;
      }

      return `Your Order - ${displayId}`;
    },
    manageOrderNumbersEnabled() {
      return this.$store.getters["login/isUpdateOrderNumbersEnabled"];
    },
    currentOrderDetails() {
      return this.orders;
    },
    isBuyer() {
      return this.getAccountType === 'buyer'
    },
    currentOrderDetailsFirstItem() {
      return this.currentOrderDetails.length ? this.currentOrderDetails[0] : null;
    },
    isContract() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.offer_type === "Contract";
    },
    isBunkering() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.product_type === "Bunkering";
    },
    isDeliveredIn() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.haulage;
    },
    currentOrderHasBeenEdited() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.edited;
    },
    currentOrderHasBeenConfirmed() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.status !== 'INCOMPLETE';
    },
    currentOrderHasBeenCancelled() {
      return this.currentOrderDetailsFirstItem && this.currentOrderDetailsFirstItem.orderCancelled ? true : false;
    },
    brand: {
      get() {
        if (this.orderBasket && this.orderBasket.brand && this.sellerAccount && this.sellerAccount.brands) {
          const result = this.sellerAccount.brands.find(({ _id }) => _id === this.orderBasket.brand.brand_id);
          return result ? result.name : null;
        }
        return false;
      },
    },
    showOrderReferenceNumbers: function () {
      return this.orders.some(
        (order) => order.orderNumber || order.releaseNumber
        // || order.movementNumber
      );
    },
  },
  methods: {
    structureRefsIntoArray(references) {
      return references ? references.split(';') : []
    },
    hasMultipleRefs() {
      let references = this.structureRefsIntoArray(this.currentOrderDetailsFirstItem.reference);
      if ((this.isContract || this.isBunkering) && references.length > 1) {
        return true;
      } else {
        return false;
      }
    },
    getReferenceLineNumber(index) {
      let references = this.currentOrderDetailsFirstItem.reference.split(';');
      let currentReference = references[index];
      return currentReference ? currentReference.trim() : '-';
    },
    calculateOrderDisplay() {
      return getOrderStatusDisplay(this.currentOrderDetailsFirstItem);
    },
    toggleExpand(row, index) {
      let currentTable = this.$refs.table;
      currentTable.toggleRowExpansion(row);
      if (this.expandedRowIndex.includes(index)) {
        this.expandedRowIndex = this.expandedRowIndex.filter((x) => x !== index);
      } else {
        this.expandedRowIndex.push(index);
      }
    },
    stringToNumber(value) {
      return formatStringToNumber(value);
    },
    tableHeaderClass({ row, rowIndex }) {
      return "dark-header-row";
    },
    getBuyerUserSellerAccount: async function () {
      const [buyerUser, sellerAccount] = await Promise.all([
        this.getBuyerUserDetails(),
        getAccountInformation(this.orders[0].seller._id),
      ]);
      if (buyerUser) {
        if (buyerUser.accountId !== sellerAccount.id) {
          this.buyerUser = buyerUser;
        } else {
          this.buyerUser = { firstName: this.orders[0].account, lastName: "", email: "", _id: "" };
        }
      }
      if (sellerAccount) {
        this.sellerAccount = sellerAccount;
      }
    },
    getBuyerUserDetails: function () {
      const buyerUserId = (this.orderBasket && this.orderBasket.user_id) || this.orders[0].createdby_id;
      return getUserInformation(buyerUserId);
    },
    closeModal() {
      $("#orderIdReceiptModal").modal("hide");
      this.$emit("hideOrderIdReceipt", false);
    },
    goToChat(buyerUserId) {
      this.startConversation(buyerUserId)
        .then((response) => {
          this.goToOlfChat(buyerUserId);
          this.closeModal();
        })
        .catch((err) => {
          this.goToOlfChat(buyerUserId);
          this.closeModal();
        });
    },
    closeModalAndConfirmOrder() {
      $("#orderIdReceiptModal").modal("hide");
      this.$emit("hideOrderIdReceipt", true);
    },
    tableRowClassName({ row }) {
      return row.lineItemCancelled ? 'warning-row' : '';
    }
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/scss/components/_modals.scss";

::v-deep .modal-xl {
  min-width: 95%;
}

.customCard {
  .el-card {
    border: none;
  }
}

</style>